export class Information {
  constructor(
    public phone: string,
    public address: string,
    public zip: string,
    public city: string,
    public email?: string
  ) {  }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/start/information.ts
 **/